<template>
  <div class="main-wrap">
    <GuestNav />
    <!-- The page (login/register) will render its own content below -->
    <router-view />
  </div>
</template>

<script setup>
import GuestNav from '@/components/guest/GuestNav.vue'
</script>
